import { Colors, Language, Lightning } from '@lightningjs/sdk'

export default class onAir extends Lightning.Component {
  static _template() {
    return {
      Label: {
        w: 100,
        h: 30,
        x: 0,
        y: 0,
        color: Colors('white').get(),
        text: {
          highlight: true,
          highlightColor: 0xffed1a3b,
          highlightPaddingLeft: 30,
          highlightPaddingRight: 30,
          offsetY: 24,
          text: Language.translate('OnAir'),
          textAlign: 'center',
          fontSize: 22,
          fontFace: 'OpenSansBold',
          lineHeight: 30,
        },
      },
    }
  }

  set onAirLabel(txt) {
    this.tag('Label').text = txt

    // this.tag('Label').loadTexture();
  }

  _init() {}
}
